import { ComponentRef, Injectable } from '@angular/core';
import { ApplicationService } from '../../utilities/application/application.service';
import { FormCoreModule } from '../form-core.module';

@Injectable({
  providedIn: FormCoreModule
})
export class ModalInstanceService {

  componentRef: ComponentRef<any> | undefined

  constructor(private app: ApplicationService) { }

  destroy() {
    if (this.componentRef) {
      this.app.destroy(this.componentRef)
      this.componentRef = undefined
      document.body.style.overflow = ''
    }
  }

}